import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "contact-info" }
const _hoisted_2 = { class: "contact-info__title" }

import useContext from '@/composables/useContext';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactInfo',
  props: {
  contact: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { texts } = useContext();




return (_ctx: any,_cache: any) => {
  const _component_rich_text = _resolveComponent("rich-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(texts)('footer__contact')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.contact, (info) => {
      return (_openBlock(), _createBlock(_component_rich_text, {
        key: info._uid,
        class: "contact-info__item",
        value: info.label
      }, null, 8, ["value"]))
    }), 128))
  ]))
}
}

})